import React from 'react';
interface LogoProps {
  tone?: 'dark' | 'light';
  className?: string;
}

/** Text wordmark for the pain clinic (replaces the former image logo). */
export function Logo({
  tone = 'dark',
  className = ''
}: LogoProps) {
  const light = tone === 'light';
  return <span className={`inline-flex flex-col leading-none ${className}`} data-id="element-257" data-mp="tdmneb1sphkt">
      <span className={`whitespace-nowrap font-display text-xl font-semibold tracking-tight ${light ? 'text-white' : 'text-ink'}`} data-id="element-258" data-mp="oc734l7fzf3h">
        Pijncentrum
      </span>
      <span className={`mt-1 whitespace-nowrap text-xs font-medium ${light ? 'text-white/60' : 'text-muted'}`} data-id="element-259" data-mp="fk4zyf5znkpi">
        Velsen-Noord
      </span>
    </span>;
}